/*
// SFRA FILE
// OVERWRITTEN COMPLETELY BECAUSE OF EXECUTION OF THE SFRA VERSION OF THE CART.JS AND NOT THE CORE'S
*/

'use strict';

var responsive = require('../util/responsive');
var processInclude = require('base/util');
var updateMiniCart = true;

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessageAndRemoveFromCart(data) {
    $.spinner().stop();
    var status = data.success ? 'alert-success' : 'alert-danger';

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-wishlist-messages "></div>');
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 1500);
    var $targetElement = $('a[data-pid="' + data.pid + '"]').closest('.product-info').find('.remove-product');
    var itemToMove = {
        actionUrl: $targetElement.data('action'),
        productID: $targetElement.data('pid'),
        productName: $targetElement.data('name'),
        uuid: $targetElement.data('uuid')
    };
    $('body').trigger('afterRemoveFromCart', itemToMove);
    setTimeout(function () {
        $('.cart.cart-page #removeProductModal').modal();
    }, 2000);
}
/**
 * move items from Cart to wishlist
 * returns json object with success or error message
 */
function moveToWishlist() {
    $('body').on('click', '.product-move .move', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var pid = $(this).data('pid');
        var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
        var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                displayMessageAndRemoveFromCart(data);
            },
            error: function (err) {
                displayMessageAndRemoveFromCart(err);
            }
        });
    });
}

/**
 * update cart icon according to the quantity total
 * @param {number} quantityTotal - quantity total of the cart
 */
function updateCartIcon(quantityTotal) {
    const showActiveIcon = quantityTotal > 0;

    $('.minicart-icon')
        .toggleClass('icon-cart-active', showActiveIcon)
        .toggleClass('icon-cart', !showActiveIcon);

    if ($('.minicart .minicart-flyout-quantity')) {
        $('.minicart .minicart-flyout-quantity').text(quantityTotal);
    }
}

/**
 * triggers the cart icon update when quantity of cart changes
 */
function triggerCartIconUpdate() {
    $('.minicart').on('count:update', (event, count) => {
        updateCartIcon(count.quantityTotal);
    });

    $('body').on('cart:update', function () {
        let quantityTotal = parseInt($('.minicart-quantity')[0].innerHTML, 10);
        updateCartIcon(quantityTotal);
    });
}

/**
 * Open flyout
 */
function flyout() {
    // dont open minicart flyout on mobile devices
    if (!responsive.isMobile()) {
        $('.minicart').on('mouseenter focusin touchstart', function () {
            $('.modal-background-page').show();

            var count = parseInt($('.minicart .minicart-quantity').text(), 10);

            // empty cart
            if (count === 0 && $('.minicart .popover.show').length === 0) {
                var title = $('.empty-basket-content').data('title');
                var text = $('.empty-basket-content').data('text');

                var html = `<h1 class="h3 p-3 border-bottom mb-3 font-weight-bold">${title}</h1><p class="h5 mb-3 p-3 font-weight-bold text-center">${text}</p>`;

                $('.minicart .popover').addClass('show empty');
                $('.minicart .popover').empty();
                $('.minicart .popover').append(html);
            }
        });

        $('.minicart').on('mouseleave focusout', function () {
            $('.modal-background-page').hide();
        });
    }
}

/**
 * Loads minicart data on pageload
 * used for analytics
 */
function loadCartData() {
    var url = $('.minicart').data('action-url');
    var count = parseInt($('.minicart .minicart-quantity').text(), 10);

    if (count !== 0) {
        $.get(url, function (data) {
            $('.minicart .popover').empty();
            $('.minicart .popover').append(data);
            $('body').trigger('minicart:pageload');
        });
    }
}

module.exports = {
    moveToWishlist: moveToWishlist,
    triggerCartIconUpdate: triggerCartIconUpdate,
    flyout: flyout,
    loadCartData: loadCartData,
    function: function () {
        processInclude(require('../cart/cart'));

        $('.minicart').on('count:update', function (event, count) {
            if (count && $.isNumeric(count.quantityTotal)) {
                $('.minicart .minicart-quantity').text(count.quantityTotal);
                $('.minicart .minicart-link').attr({
                    'aria-label': count.minicartCountOfItems,
                    title: count.minicartCountOfItems
                });
            }
        });

        $('.minicart').on('mouseenter focusin touchstart', function () {
            if ($('.search:visible').length === 0) {
                return;
            }
            var url = $('.minicart').data('action-url');
            var count = parseInt($('.minicart .minicart-quantity').text(), 10);

            if (count !== 0 && $('.minicart .popover.show').length === 0) {
                if (!updateMiniCart) {
                    $('.minicart .popover').addClass('show');
                    return;
                }

                $('.minicart .popover').addClass('show');
                $('.minicart .popover').spinner().start();
                $.get(url, function (data) {
                    $('.minicart .popover').empty();
                    $('.minicart .popover').append(data);
                    updateMiniCart = false;
                    $.spinner().stop();
                });
            }
        });
        $('body').on('touchstart click', function (e) {
            if ($('.minicart').has(e.target).length <= 0) {
                $('.minicart .popover').removeClass('show');
            }
        });
        $('.minicart').on('mouseleave focusout', function (event) {
            if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
                || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
                || $('body').hasClass('modal-open')) {
                event.stopPropagation();
                return;
            }
            $('.minicart .popover').removeClass('show');
        });
        $('body').on('change', '.minicart .quantity', function () {
            if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
                location.reload();
            }
        });
        $('body').on('product:afterAddToCart', function () {
            updateMiniCart = true;
        });
        $('body').on('cart:update', function () {
            updateMiniCart = true;
        });

        $('body').on('click', '.js-toggle-personalisationtxt', function () {
            var $button = $(this);
            $button.closest('.product-line-item').find('.js-productcard-personalisationtxt').toggleClass('text-truncate');

            if ($button.text() === $button.data('txt-more')) {
                $button.text($button.data('txt-less'));
            } else {
                $button.text($button.data('txt-more'));
            }
        });
    }
};
